module.exports = __webpack_public_path__ + "img/logo.22f4d4c6.svg";